namespace GeniuzPOS.Purchase {
    export interface PoInvoiceReceivePrintData extends Serenity.ListRequest {
        Para?: Administration.CsParaRow;
        Header?: PoInvoiceReceiveRow;
        Supdata?: Supplier.CsSupplierRow;
        Details?: PoInvoiceReceiveDtRow[];
        SysDocNo?: string;
        URLpic?: string;
        Paydesc?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
